import React from 'react';
import { Chip, styled, Tooltip } from '@mui/material';

// Styled components
export const StyledChip = styled(Chip)(({ theme }) => ({
  fontSize: '0.775rem',
  zIndex: 2,
  padding: `${theme.spacing(0.25)} 0`,
  marginRight: theme.spacing(2),
  fontWeight: 'bold',
  textTransform: 'uppercase',
}));

const DisabledVariableChip = () => (
  <Tooltip title="Only one variable configuration can be enabled at once." arrow placement="top-start">
    <span>
      <StyledChip label="Variable" size="small" disabled />
    </span>
  </Tooltip>
);

export default DisabledVariableChip;
